module.exports = __webpack_public_path__ + "img/step_one_brands.28ab0ada.jpg";